import { createV3Queries } from "@query/utils/createV3Queries";
import { stakeholdersApi } from "@api";

export const queriesStakeholders = createV3Queries(
  "stakeholdersApi",
  stakeholdersApi,
  {
    createAccountStakeholder: queries => ({
      dependencies: () => [queries.listAccountStakeholders.queryKeyBase]
    }),
    updateStakeholder: queries => ({
      dependencies: () => [
        queries.listAccountStakeholders.queryKeyBase,
        queries.getStakeholder.queryKeyBase
      ]
    }),
    revokeStakeholder: queries => ({
      dependencies: () => [
        queries.listAccountStakeholders.queryKeyBase,
        queries.getStakeholder.queryKeyBase
      ]
    })
  }
);
